module.exports = __webpack_public_path__ + "media/images/brand/logo-01-ff810fbe0aec9f26cb7615078e1946ee.png";